import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Api from '../cmp/admin/cmp/api/api';
import DOMPurify from 'dompurify';
import { Oval as Loader } from 'react-loader-spinner';
import { useLocation } from 'react-router-dom';

const RecipeDetail = () => {
    const navigate = useNavigate
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const recipe = location.state?.recipe;

    // console.log('recipe_type: ' + JSON.stringify(recipe.recipe_type));
    // console.log('meal_type: ' + JSON.stringify(recipe.meal_type));


    if (!recipe) {
        return <div style={{ padding: 40 }}>Recipe not found.</div>;
    }

    const cleanHtml = DOMPurify.sanitize(recipe.body);

    return (
        <main style={{ width: "min(900px, 94%)", margin: "40px auto", color: "#333" }}>
            {/* <div style={{ marginBottom: 20 }}>
                <Link onClick={()=>{navigate(-1)}} style={{ color: "#02af90", textDecoration: "none" }}>← Back to Mind Articles</Link>
            </div> */}

            <h1 style={{ fontSize: "2rem", marginBottom: 20, lineHeight: 1.3 }}>
                {recipe.title}
            </h1>

            {recipe.images?.length > 0 && (
                <img
                    src={recipe.images[0]}
                    alt={recipe.title}
                    style={{
                        width: "100%",
                        height: "auto",
                        borderRadius: 12,
                        objectFit: "contain",
                        marginBottom: 25,
                        boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
                    }}
                />
            )}

            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "25px 30px",
                    borderRadius: 10,
                    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                    fontSize: "1.1rem",
                    lineHeight: 1.7
                }}
                dangerouslySetInnerHTML={{ __html: cleanHtml }}
            />

            <div style={{marginTop:30}}>
                Recipe Type:
            </div>
            <div style={{display:'flex', gap:10, flexWrap:'wrap', marginTop:10}}>
                {recipe.recipe_type.map((item) => {
                    return (
                        <div style={{ padding: 10, backgroundColor: '#02af90', borderRadius: 5, color: 'white', fontSize:16 }}>{item}</div>
                    )
                })}
            </div>

            <div style={{marginTop:30}}>
                Meal Type:
            </div>
            <div style={{display:'flex', gap:10, flexWrap:'wrap', marginTop:10}}>
                {recipe.meal_type.map((item) => {
                    return (
                        <div style={{ padding: 10, backgroundColor: '#02af90', borderRadius: 5, color: 'white', fontSize:16 }}>{item}</div>
                    )
                })}
            </div>

        </main>
    );
};

export default RecipeDetail;
